import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { db } from "@/lib/local/db";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useFiscalStore } from "@/store/fiscal-store";

export function RootRedirect() {
  const [target, setTarget] = useState<string | null>(null);
  const { user, loading } = useAuth();
  const storeUserId = useFiscalStore(s => s.userId);

  useEffect(() => {
    async function checkData() {
      if (loading) return;

      // Se não há usuário autenticado, manda para login
      if (!user) {
        setTarget("/login");
        return;
      }

      const activeUserId = user.id;

      try {
        // Garante que o store tenha o ID correto para os watchers
        if (storeUserId !== activeUserId) {
          useFiscalStore.getState().setUserId(activeUserId);
        }

        const count = await db.notas.where("userId").equals(activeUserId).count();
        if (count > 0) {
          setTarget("/dashboard");
        } else {
          setTarget("/upload");
        }
      } catch (err) {
        console.error("[RootRedirect] Erro ao verificar dados:", err);
        setTarget("/upload");
      }
    }
    checkData();
  }, [user, loading, storeUserId]);

  if (!target) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <Loader2 className="size-8 text-primary animate-spin" />
      </div>
    );
  }

  return <Navigate to={target} replace />;
}
